export enum AutomotiveDepartment {
  SERVICE = '1',
  SALES = '2',
}

export const automotiveDepartmentOptions = [
  { value: '1', label: 'Service' },
  { value: '2', label: 'Sales' },
];
